// extracted by mini-css-extract-plugin
export default {"root":"cWRof","button":"a7Mdy","icon":"dX821"};